import { getPrices, list } from "./endpoints";

export {
  ListModelsResponse,
  Model,
  ModelName,
  ModelParams,
  ModelPricesResponse,
  PriceRow,
  Sku,
  SkuId,
} from "./schemas";
export { service } from "./service";

export const contract = {
  list,
  prices: { get: getPrices },
} as const;
